import { MyUrls } from "./MyWorkUrls";

export class OnOffline {
    static async isOnOffline(){
        //console.log('ping')
        return new Promise((resolve,reject) => {
            
            var xhr = new XMLHttpRequest();
            xhr.withCredentials = true;
            xhr.open('GET', MyUrls.getBackend(), true);
            //xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.addEventListener('load', function() {
                //console.log(this)
                /*@ts-ignore*/
                if (this.status == 200){
                    resolve('success')
                }else{
                    reject("no connection")
                }
            });
            xhr.addEventListener('error', function(e) {
                //console.log(e)
                reject("no connection")
            });
            xhr.onreadystatechange = function() {
                if (this.readyState == 4 && this.status == 200) {
                    //console.log('online')
                }
            };
            //console.log(xhr)
            xhr.send();
        })
    }
}